export default {
  logging: 'Connexion en cours...',
  logCall: 'Journal des appels',
  editLog: 'Modifier le journal',
  select: 'Sélectionner un enregistrement correspondant',
  OnHold: 'En attente',
  Ringing: 'Sonnerie en cours',
  CallConnected: 'Appel établi',
  unknownUser: 'Utilisateur inconnu',
  unknownNumber: 'Anonyme',
  unavailable: 'Non disponible',
  viewDetails: 'Afficher les détails',
  'phoneSource.systemUser': '(Utilisateur système)',
  'phoneSource.account': '(Compte)',
  'phoneSource.contact': '(Contact)',
  'phoneSource.lead': '(Piste)',
  'phoneType.phone': '(Téléphone)',
  'phoneType.home': '(Téléphone domicile)',
  'phoneType.business': '(Téléphone bureau)',
  'phoneType.mobile': '(Téléphone mobile)',
  'phoneType.unknown': '(Type de téléphone inconnu)',
};
